import uniq from 'lodash.uniq'

import { tabs } from 'modules/SlotsRoot/data/tabs'
import { tabsLive } from 'modules/SlotsRoot/data/tabsLive'

export const excludePgramaticList: string[] = [
  'pragmaticexternal:MonkeyWarrior',
  'pragmaticexternal:ChilliHeat',
  'pragmaticexternal:MoneyMouse',
  'pragmaticexternal:LuckyNewYear',
  'pragmaticexternal:PyramidKing1',
  'pragmaticexternal:WildWestGold',
  'pragmaticexternal:UltraHoldandSpin',
  'pragmaticexternal:AztecGemsDeluxe1',
  'pragmaticexternal:JohnHunterandtheBookofTut',
  'pragmaticexternal:DiamondStrike',
  'pragmaticexternal:TripleTigers',
  'pragmaticexternal:GreatRhinoDeluxe',
  'pragmaticexternal:FireStrike',
  'pragmaticexternal:MasterJoker',
  'pragmaticexternal:CaishensGold',
  'pragmaticexternal:DragonKingdom',
  'pragmaticexternal:FruitRainbow',
  'pragmaticexternal:CurseoftheWerewolfMegaways',
  'pragmaticexternal:TheDogHouse',
  'pragmaticexternal:5LionsDance',
  'pragmaticexternal:GreatRhino',
  'pragmaticexternal:WolfGold',
  'pragmaticexternal:BuffaloKing',
  'pragmaticexternal:BigBassBonanza',
  'pragmaticexternal:FloatingDragon1',
  'pragmaticexternal:FruitParty1',
  'pragmaticexternal:SweetBonanza',
  'pragmaticexternal:GatesOfOlympus1',
  'pragmaticexternal:TheHandOfMidas',
  'pragmaticexternal:SweetBonanzaXmas',
  'pragmaticexternal:HotFiesta1',
  'pragmaticexternal:LuckyDragons',
  'pragmaticexternal:HerculesSonZeus',
  'pragmaticexternal:5Lions',
  'pragmaticexternal:JuicyFruits',
  'pragmaticexternal:DropsandWinsLobby',
  'pragmaticexternal:lobby',
  'pragmaticexternal:GameShowLobby',
  'pragmaticexternal:BlackjackLobby',
  'pragmaticexternal:BaccaratLobby',

  'pragmaticexternal:5LionsGold',
  'pragmaticexternal:SpartanKing',
  'pragmaticexternal:BiggerBassBonanza',
  'pragmaticexternal:WildWildRiches',
  'pragmaticexternal:TheDogHouseMegaways1',
  'pragmaticexternal:ChristmasCarolMegaways1',
  'pragmaticexternal:BuffaloKingMegaways1',
  'pragmaticexternal:ReleasetheKraken',
  'pragmaticexternal:Cowboysgold1',
  'pragmaticexternal:PowerofThorMegaways',
  'pragmaticexternal:MadameDestinyMegaways1',
  'pragmaticexternal:GreatRhinoMegaways',
  'pragmaticexternal:CongoCash1',
  'pragmaticexternal:GoldTrain',
  'pragmaticexternal:PirateGoldDeluxe1',
]

export const excludeSoftwissList: string[] = [
  // 'merkur',
  // 'gtech',
  // 'swintt',
  // 'tomhorn',
  // 'betsoft',
  // 'augustgaming',
  // 'blueprint',
  // 'kiron',
  'evolution',
  'fazi',
  'endorphina',
  'pragmaticexternal',
  'fugaso',
  '3oaks',
  'tomhornnative',
  'igtech',
  'pragmaticplaylive',
  'nucleus',
  'gameart',
  'petersons',
  'yggdrasilgaming',
  'yggdrasil',
  '4theplayer',
  'epicmedia',
  'pragmaticplay',
  'pragmaticplaylive',
  'booongo',
] // not support PYG currency

// function getSections(gameList) {
//   const sections = gameList.reduce(
//     (types, item) => (types.indexOf(item.sectionId) !== -1 ? types : [...types, item.sectionId]),
//     [],
//   );
//   sections.unshift('all');
//   return sections;
// }

export function getTab(slotId: string, slotName: string): string[] {
  let additionalTabs = []
  if (slotId.toLowerCase().indexOf('megaways') !== -1 || slotName.toLowerCase().indexOf('megaways') !== -1) {
    additionalTabs.push('megaways')
  }
  const trueTab = Object.keys(tabs).reduce(
    (acc: string[], tab: string) =>
      tabs[tab].findIndex((item: string) => item === slotId) === -1 ? acc : [...acc, tab],
    [],
  )
  return uniq([...additionalTabs, ...trueTab])
}

export function getTabLive(slotId: string, dropAndWins?: boolean): string[] {
  const additionalTabs: string[] = dropAndWins ? ['Drops & Wins'] : []
  const trueTab = Object.keys(tabsLive).reduce(
    (acc: string[], tab: string) =>
      tabsLive[tab].findIndex((item: string) => item === slotId) === -1 ? acc : [...acc, tab],
    [],
  )
  return trueTab.concat(additionalTabs)
}

// export { getTab };
